import styled from 'styled-components';

export const UiPrompt = styled.div`
	display: block;
	padding: 1rem;
	font-weight: bold;
	border: 1px solid #d8edf0;
	letter-spacing: 2px;
`;
